




import { Emit, Watch, Component, Prop, Vue } from 'vue-property-decorator';
import dayjs from 'dayjs';

@Component({ components: {} })
export default class WxClock extends Vue {
    @Prop(Boolean) private hideSeconds!: boolean;

    private time = Date.now();

    get display() {
        let formatStr = 'HH:mm:ss';
        if (this.hideSeconds) {
            formatStr = 'HH:mm';
        }
        return dayjs(this.time).format(formatStr);
    }

    private created() {
        setInterval(() => {
            this.time = Date.now();
        }, 1000);
    }
}
